<template>
  <div class="card border-inside">
    <div class="card-content info-list">
      <div v-if="$i18n.locale === 'th'" class="content th">
        <p>
          <span class="has-text-weight-normal">Business information:</span>
          แสดงข้อมูลเบื้องต้นของบริษัทและสามารถแก้ไขข้อมูล ดังนี้
        </p>
        <ul>
          <li>Name of business or team (ชื่อบริษัท หรือ ชื่อทีม)</li>
          <li>
            Business group (กลุ่มธุรกิจ) แบ่งเป็น
            <ul>
              <li>SMEs (วิสาหกิจขนาดกลางและขนาดย่อม)</li>
              <li>
                Startup (กิจการที่ตั้งขึ้นเพื่อค้นหาโมเดลธุรกิจ (Business model)
                ที่ทำซ้ำได้ (Repeatable) และขยายตัวได้ (Scalable)
                <i>อ้างอิงจาก: Steve Blank บิดาแห่งสตาร์ทอัพ</i>
              </li>
            </ul>
          </li>
          <li>
            Business type (ลักษณะของธุรกิจ) แบ่งเป็น
            <ul>
              <li>Manufacturing (ธุรกิจผลิต)</li>
              <li>Service (ธุรกิจบริการ)</li>
            </ul>
          </li>
          <li>
            Telephone of business or team (Optional) (เบอร์โทรศัพท์บริษัท หรือ
            ทีม)
          </li>
          <li>Website of business (Optional) (เว็บไซต์บริษัท)</li>
          <li>Address (ที่อยู่)</li>
          <li>Postcode (รหัสไปรษณีย์)</li>
          <li>Sub-district (ตำบล/แขวง)</li>
          <li>City/District (อำเภอ/เขต)</li>
          <li>Province (จังหวัด)</li>
          <li>Country (ประเทศ)</li>
          <li>Company logo (โลโก้บริษัท)</li>
        </ul>
      </div>
      <div v-else class="content th">
        <p>
          <span class="has-text-weight-normal">Business information:</span>
          Show basic information of the company and can edit information as
          follows
        </p>
        <ul>
          <li>Name of business or team</li>
          <li>
            Business group
            <ul>
              <li>SMEs</li>
              <li>
                Startup an entity established to find business model,
                Repeatable, Scalable
                <i>Ref: Steve Blank</i>
              </li>
            </ul>
          </li>
          <li>
            Business type
            <ul>
              <li>Manufacturing</li>
              <li>Service</li>
            </ul>
          </li>
          <li>Telephone of business or team (Optional)</li>
          <li>Website of business (Optional)</li>
          <li>Address</li>
          <li>Postcode</li>
          <li>Sub-district</li>
          <li>City/District</li>
          <li>Province</li>
          <li>Country</li>
          <li>Company logo</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>